import { LogOut, Menu, UserRound } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { ThemeToggle } from '@/components/common/ThemeToggle';
import { DevRoleSelector } from '@/components/common/DevRoleSelector';
import { useAuth } from '@/auth/AuthProvider';

export function Header({ onOpenNavigation }: { onOpenNavigation: () => void }): JSX.Element {
  const { principal, signOut } = useAuth();
  return (
    <header className="flex min-w-0 items-center justify-between gap-2 border-b bg-card/60 px-3 py-3 sm:px-6">
      <div className="flex min-w-0 items-center gap-3">
        <Button
          variant="ghost"
          size="icon"
          className="md:hidden"
          onClick={onOpenNavigation}
          aria-label="Open navigation"
          title="Open navigation"
        >
          <Menu className="h-4 w-4" />
        </Button>
        {principal?.roles.map((role) => (
          <Badge key={role} variant="outline">
            {role}
          </Badge>
        ))}
      </div>
      <div className="flex min-w-0 items-center gap-2 sm:gap-3">
        <DevRoleSelector />
        <div className="hidden items-center gap-2 text-sm sm:flex">
          <UserRound className="h-4 w-4 text-muted-foreground" />
          <div className="flex flex-col leading-tight">
            <span className="font-medium">{principal?.displayName ?? 'Unknown'}</span>
            <span className="text-xs text-muted-foreground">{principal?.username ?? ''}</span>
          </div>
        </div>
        <ThemeToggle />
        <Button variant="ghost" size="sm" onClick={signOut} aria-label="Sign out">
          <LogOut className="h-4 w-4" />
          <span className="hidden sm:inline">Sign out</span>
        </Button>
      </div>
    </header>
  );
}
